import { StyledDrawerMenu } from "@lib/components/AppComponents/AppLayout/Admin/index.styled";
import AppLogo from "@lib/components/AppComponents/AppLayout/components/AppLogo";
import AppVerticalMenu from "../components/AppVerticalNav";
import AdminSidebarFooter from "@lib/components/AppComponents/AppLayout/Admin/AdminSidebarFooter";
import { IRouteConfig } from "@lib/types/Routes";

type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
  routesConfig: IRouteConfig[];
  height: number;
};

export default function AdminDrawerMenu({
  open,
  setOpen,
  routesConfig,
  height,
}: Props) {
  return (
    <StyledDrawerMenu
      open={open}
      onClose={() => setOpen(false)}
      placement="left"
      width={250}
      title={<AppLogo />}
      headerHeight={height}
    >
      <AppVerticalMenu routesConfig={routesConfig} isDrawer />

      <AdminSidebarFooter />
    </StyledDrawerMenu>
  );
}
